// Popup configuration — CMS-driven via Sanity.
// Source of truth: Sanity → cms-code/sanity/generated/popup.json → src/cms/popup.json.
// Edit popups in the Studio (each popup has its own On/Off switch + optional schedule).
// The legacy seed lives in cms-code/sanity/scripts/source-data/popup-source-data.js.
import popup from '../../cms/popup.json';

// There is no global on/off anymore — control is per-popup (each has its own "Show this popup"
// toggle). POPUP_ENABLED stays exported (always true) so Popup.jsx keeps working unchanged.
export const POPUP_ENABLED = true;

// Preview aid: show the active popup on every reload instead of once per 2 hours.
// Dev-only — leave false for the live site.
export const POPUP_TESTING_MODE = false;

export const scheduledPopups = popup.popups || [];

// ============================================================================
// AUTO-SELECTION LOGIC
// ============================================================================
// A popup is "live" when it is turned On AND today is within its date window
// (dates are optional: no start = live immediately, no end = no expiry).
// Only ONE popup ever shows: if several are live, the lowest priority order wins
// (scheduledPopups arrives pre-sorted by sortOrder). Returns null if none are live.
// ============================================================================

const isLive = (p, now) => {
  if (p.enabled === false) return false;
  const start = p.startDate ? new Date(p.startDate) : null;
  const end = p.endDate ? new Date(p.endDate) : null;
  return (!start || now >= start) && (!end || now <= end);
};

const getCurrentPopup = () => {
  const now = new Date();
  return scheduledPopups.find((p) => isLive(p, now)) || null;
};

export const popupConfig = getCurrentPopup();
